const BEDROCK_ARN_PATTERN = /^arn:aws:bedrock:[a-z0-9-]*:[0-9]*:.+/
const BEDROCK_ARN_MESSAGE = 'Must be a Bedrock ARN (arn:aws:bedrock:…).'

export const PROVIDER_FIELDS = [
  { name: 'providerId', label: 'Provider ID', type: 'text', maxLength: 64, readOnlyOnEdit: true, placeholder: 'auto-generate if blank' },
  { name: 'name', label: 'Name', type: 'text', required: true, maxLength: 256 },
  { name: 'ordinal', label: 'Ordinal', type: 'number', defaultValue: 10000 }
]

export const MODEL_FIELDS = [
  { name: 'modelId', label: 'Model ID', type: 'text', maxLength: 64, readOnlyOnEdit: true, placeholder: 'auto-generate if blank' },
  { name: 'name', label: 'Name', type: 'text', maxLength: 256 },
  { name: 'providerId', label: 'Provider', type: 'select', required: true, optionsKey: 'providers' },
  { name: 'arn', label: 'Bedrock ARN', type: 'text', required: true, maxLength: 256, placeholder: 'arn:aws:bedrock:us-east-1::foundation-model/…', pattern: BEDROCK_ARN_PATTERN, patternMessage: BEDROCK_ARN_MESSAGE },
  { name: 'inputPriceFactor', label: 'Input price (per 1K tokens)', type: 'number', step: '0.00000001', defaultValue: 0 },
  { name: 'outputPriceFactor', label: 'Output price (per 1K tokens)', type: 'number', step: '0.00000001', defaultValue: 0 },
  { name: 'maxTokens', label: 'Max tokens', type: 'number', defaultValue: 10000 },
  { name: 'requestsPerMinute', label: 'Requests per minute', type: 'number', defaultValue: 500 },
  { name: 'enabled', label: 'Enabled', type: 'checkbox' },
  { name: 'hidden', label: 'Hidden', type: 'checkbox' }
]

export const TASK_FIELDS = [
  { name: 'taskCode', label: 'Task code', type: 'text', maxLength: 32, readOnlyOnEdit: true, placeholder: 'auto-generate if blank' },
  { name: 'name', label: 'Name', type: 'text', required: true, maxLength: 64 },
  { name: 'description', label: 'Description', type: 'textarea', rows: 3 },
  { name: 'model1', label: 'Primary model', type: 'select', required: true, optionsKey: 'models' },
  { name: 'model2', label: 'Fallback model 1', type: 'select', optionsKey: 'models', allowEmpty: true },
  { name: 'model3', label: 'Fallback model 2', type: 'select', optionsKey: 'models', allowEmpty: true },
  { name: 'maxTokens', label: 'Max tokens', type: 'number', min: 1, required: true },
  { name: 'temperature', label: 'Temperature', type: 'number', step: '0.0001', min: 0, max: 2, required: true },
  { name: 'guardrailId', label: 'Guardrail', type: 'select', optionsKey: 'guardrails', allowEmpty: true }
]

export const GUARDRAIL_FIELDS = [
  { name: 'guardrailId', label: 'Guardrail ID', type: 'text', maxLength: 64, readOnlyOnEdit: true, placeholder: 'auto-generate if blank' },
  { name: 'name', label: 'Name', type: 'text', required: true, maxLength: 256 },
  { name: 'description', label: 'Description', type: 'textarea', required: true, rows: 3 },
  { name: 'arn', label: 'Bedrock ARN', type: 'text', required: true, maxLength: 256, placeholder: 'arn:aws:bedrock:us-east-1:…:guardrail/…', pattern: BEDROCK_ARN_PATTERN, patternMessage: BEDROCK_ARN_MESSAGE },
  { name: 'version', label: 'Version', type: 'text', required: true, maxLength: 64 },
  { name: 'enabled', label: 'Enabled', type: 'checkbox' },
  { name: 'hidden', label: 'Hidden', type: 'checkbox' }
]
